import pluralize from 'pluralize';
import React from 'react';
import {} from './ManuallyAddBankAccountHelpText.types';
const ManuallyAddBankAccountHelpText = ({ partnerCompany, partnershipCurrency, }) => {
    const currencyDetails = `${pluralize(partnershipCurrency.name)} (${partnershipCurrency.currencyCode})`;
    return (React.createElement("span", { className: "text-sm text-grey-70" },
        "You're set up to receive payments in ",
        currencyDetails,
        ". Contact ",
        partnerCompany.name,
        " if you need to change",
        ' ',
        "your currency."));
};
export default ManuallyAddBankAccountHelpText;
